module.exports = __webpack_public_path__ + "static/media/horse-saddle.e74266d7.svg";